import React from "react";
import { Container, Button } from "react-bootstrap";
import { ArrowsMove, Trash } from "react-bootstrap-icons";

class EvaluationFormulaFormulaElement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      term: undefined,
      elements: [],
      show: true,
    };
  }

  render() {
    let { tag, onRemove } = this.props;

    return (
      <>
        <Button onClick={onRemove}>
          <ArrowsMove className="display-on-hover" />
          &nbsp;
          {tag}
          &nbsp;
          <Trash className="display-on-hover" />
        </Button>
      </>
    );

  };
}

export default EvaluationFormulaFormulaElement;